// src/pages/PaymentPage.js
import React from 'react';
import { StripeProvider } from '../../contexts/stripeContext';
import PaymentForm from '../../components/paymentForm/paymentForm';

const PaymentPage = () => {
  return (
    <StripeProvider>
      <div>
        <PaymentForm />
      </div>
    </StripeProvider>
  );
};

export default PaymentPage;
